export const AppConstants = {
	emailPattern: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
	phonePattern: '[7-9]{1}[0-9]{9}',
	data: [],
	block: [],
	blocks: [],
	blocks_f: [],
	flows: [],
	projects:[],
	categories: [],
	pagination: {
		offset: 0,
		limit: 10,
		currentPage: 1,
		pageSizeOptions: [10, 30, 50, 100]
	},
	dateRangePickerConfig: {
        rangeInputFormat: 'DD-MMM-YY',
        dateInputFormat: 'DD-MMM-YY',
        showWeekNumbers: false,
        containerClass: 'theme-default',
        adaptivePosition: true,
    },
	defaultDateFormat:  'dd-MMM-yy hh:mm a',
	debounceTime: 2000
};
